import { render, staticRenderFns } from "./SalesInfo.vue?vue&type=template&id=4ff24dec&scoped=true"
import script from "./SalesInfo.vue?vue&type=script&lang=js"
export * from "./SalesInfo.vue?vue&type=script&lang=js"
import style0 from "./SalesInfo.vue?vue&type=style&index=0&id=4ff24dec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff24dec",
  null
  
)

export default component.exports